import { CalendarOutlined, ClockCircleOutlined, CloudOutlined, ContainerOutlined, CopyOutlined, DollarCircleOutlined, FileExcelOutlined, FolderOutlined, FormatPainterOutlined, LineChartOutlined, SettingOutlined, TeamOutlined, UsergroupAddOutlined } from '@ant-design/icons';

import Page from '../../Components/Page/Page';
import { TextService } from '../../Services/TextService';
import { Crumbs, CtaBanner, FeatureGrid, Hero, SectionHead, useScrollTop } from '../Start2/Marketing2';
import '../Start2/Start2.css';

// Swedish features page (/se/features/organisations). English still uses FeaturesMemberOrganisations.tsx,
// since parts of this page are hardcoded in Swedish.
const FeaturesMemberOrganisationsSe = () => {
  const GetText = TextService.GetText;
  useScrollTop();
  const f = (n: string) => ({ title: GetText(`FeaturesMemberOrganisations_Feature${n}Title`), html: GetText(`FeaturesMemberOrganisations_Feature${n}Text`) });
  const s = (key: string) => ({ title: GetText("Start_EventFeatureTitle" + key), html: GetText("Start_EventFeatureDescription" + key) });

  const more = [
    { icon: <SettingOutlined />, ...f("5") },
    { icon: <UsergroupAddOutlined />, ...f("8") },
    { icon: <TeamOutlined />, title: "Familjemedlemmar", html: "Koppla familjemedlemmar till en huvudmedlem och hantera hela familjen samlat." },
    { icon: <DollarCircleOutlined />, ...f("6") },
    { icon: <CalendarOutlined />, ...f("7") },
    { icon: <ClockCircleOutlined />, ...s("3") },
    { icon: <CopyOutlined />, ...s("6b") },
    { icon: <ContainerOutlined />, ...s("6c") },
    { icon: <LineChartOutlined />, ...f("4") },
    { icon: <FileExcelOutlined />, ...f("9") },
    { icon: <CloudOutlined />, title: GetText("Start_EventFeatureTitle4"), html: "Webbformulär för integration med din befintliga site för att skapa ny medlem/ändra medlem." },
    { icon: <FormatPainterOutlined />, ...s("7") },
    { icon: <FolderOutlined />, ...s("9") },
  ];

  return <Page className='start2' pageTitle={GetText("PageTitle_MemberOrganisations")} metaDescription="Funktioner för föreningar: medlemshantering, betalningar, e-post, GDPR och mer. Allt i ett system.">

    <Hero
      crumb={<Crumbs current="Funktioner" />}
      title={GetText("FeaturesMemberOrganisations_Header")}
      lead={GetText("FeaturesMemberOrganisations_Description")}
      image={require('../../Images/Articles/medlemsregister-illustration.png')}
      imageAlt="Illustration av OneFront360 medlemsregister"
    />

    <section className="s2-section">
      <div className="s2-container">
        <SectionHead title={GetText("FeaturesMemberOrganisations_MoreFeatures")} />
        <FeatureGrid items={more} />
      </div>
    </section>

    <CtaBanner />
  </Page>
};

export default FeaturesMemberOrganisationsSe;
